/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { VaultWithLinks } from '../models/vault-with-links';
@Injectable({
  providedIn: 'root',
})
class VaultsWithLinksService extends __BaseService {
  static readonly VaultsWithLinksGetPath = '/vaults-with-links/{vaultId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Returns the vault with links
   * @param params The `VaultsWithLinksService.VaultsWithLinksGetParams` containing the following parameters:
   *
   * - `vaultId`: GUID of the vault
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  VaultsWithLinksGetResponse(params: VaultsWithLinksService.VaultsWithLinksGetParams): __Observable<__StrictHttpResponse<VaultWithLinks>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.Authorization != null) __headers = __headers.set('Authorization', params.Authorization.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/vaults-with-links/${encodeURIComponent(String(params.vaultId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VaultWithLinks>;
      })
    );
  }
  /**
   * Returns the vault with links
   * @param params The `VaultsWithLinksService.VaultsWithLinksGetParams` containing the following parameters:
   *
   * - `vaultId`: GUID of the vault
   *
   * - `Authorization`: Bearer JSON Web Token
   *
   * @return OK
   */
  VaultsWithLinksGet(params: VaultsWithLinksService.VaultsWithLinksGetParams): __Observable<VaultWithLinks> {
    return this.VaultsWithLinksGetResponse(params).pipe(
      __map(_r => _r.body as VaultWithLinks)
    );
  }
}

namespace VaultsWithLinksService {

  /**
   * Parameters for VaultsWithLinksGet
   */
  export interface VaultsWithLinksGetParams {

    /**
     * GUID of the vault
     */
    vaultId: string;

    /**
     * Bearer JSON Web Token
     */
    Authorization: string;
  }
}

export { VaultsWithLinksService }